import { gql } from '@apollo/client';

export const STANDARD_DELIVERY_DHC_REPORT_METRICS = gql`
  fragment standardDeliveryDHCReportMetricsFragment on StandardDeliveryDeviceHigherCategoryReportMetrics {
    id
    campaignId
    campaignName
    accountManager
    accountExecutive
    lineItemName
    lineItems {
      id
      adProduct
      publisher
      startDate
      endDate
      cpm
      revenue
      deliveryGoal
      lifetimeCompletions
      deviceBreakout {
        deviceName
        impressions
        completions
        deviceBreakdown
      }
    }
  }
`;
